'use strict';

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var dom = require('virtual-dom/h');

var _require = require('../helpers'),
    pattern = _require.pattern;

var defaults = {
  size: 15,
  // size of the pattern
  radius: 3,
  complement: true,
  fill: '#545454',
  // any SVG-compatible color
  strokeWidth: 0,
  stroke: 'none',
  // any SVG-compatible color
  background: null // any SVG-compatible color

};

var circles = function circles() {
  var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  opt = Object.assign({}, defaults, opt);
  var s = opt.size;
  var children = [dom('circle', {
    cx: s / 2,
    cy: s / 2,
    r: opt.radius,
    fill: opt.fill,
    stroke: opt.stroke,
    'stroke-width': opt.strokeWidth + ''
  })];
  if (opt.complement === true) for (var _i = 0, _arr = [[0, 0], [0, s], [s, s], [s, 0]]; _i < _arr.length; _i++) {
    var _arr$_i = _slicedToArray(_arr[_i], 2),
        x = _arr$_i[0],
        y = _arr$_i[1];

    children.push(dom('circle', {
      cx: x,
      cy: y,
      r: opt.radius,
      fill: opt.fill,
      stroke: opt.stroke,
      'stroke-width': opt.strokeWidth + ''
    }));
  }
  Object.assign(opt, {
    width: opt.size,
    height: opt.size,
    children: children,
    bg: opt.background
  });
  return pattern(opt);
};

module.exports = circles;